/**
 * The three flows of the data collection event page.
 * - CREATE:    /assessments/create_dce
 * - UPDATE:    /assessments/update_dce/:id
 * - DUPLICATE: /assessments/create_dce?mode=duplicate&eventId=<id>
 *              (the event is only read to pre-fill the page; saving always creates a new event)
 */
export const DCE_MODE = {
	CREATE: 'create',
	UPDATE: 'update',
	DUPLICATE: 'duplicate'
};

// Query parameter names used by the duplicate URL
export const DCE_MODE_PARAM = 'mode';
export const DCE_EVENT_ID_PARAM = 'eventId';
